import { INSIGHTS_FEEDBACK_OPTIONS, INSIGHT_STATUSES } from '@silverfort-nodelibs/common/utils/consts';
import styles from '../EntitiesPopup.module.css';

const EntityNameDisplay = ({ entityData }) => {
    const { name, display_name, isNew, insight_status } = entityData;
    return (
        <div className="name" title={name ?? display_name}>
            <div className="title">
                {name ?? display_name}
                {entityData.is_disabled && <span className={styles.entityNameDisabled}>(Disabled)</span>}
            </div>
            {isNew && <div className="newEntity">(new)</div>}
            {insight_status && insight_status !== INSIGHT_STATUSES.ACTIVE && (
                <div
                    className={
                        styles.insightStatus
                    }>{`(${INSIGHTS_FEEDBACK_OPTIONS[insight_status].filterLabel})`}</div>
            )}
        </div>
    );
};

export default EntityNameDisplay;
